import { Component, OnInit, Input } from '@angular/core';
import { Installations } from 'src/app/model/installations/installations.model';
import { InstallationsService } from 'src/app/services/http/installations/installations.service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-installations-uninstalled',
  templateUrl: './installations-uninstalled.component.html',
  styleUrls: ['./installations-uninstalled.component.scss']
})
export class InstallationsUninstalledComponent implements OnInit {

  @Input() installations : any;

  constructor(private service: InstallationsService,  private router : Router) { }

  sortOrders: number[] = [];

  // public installations!: Installations;

  ngOnInit(): void {
    // this.service.getInstallations()
    //   .subscribe((installations) => {
    //     this.installations = installations;
    //   });


  }
  sortby(column: any): void {
    console.log('Tri par la colonne ' + column);
    var sortOrder = 1;
    if(!this.sortOrders[column]){
        this.sortOrders[column] = 1;
      }
    else{
      this.sortOrders[column] = - this.sortOrders[column];
      sortOrder=this.sortOrders[column];
    }
    
    this.installations.desinstallees.sort(function (a: any, b: any) {
      var rowA = a[column];
      var rowB = b[column];
      if (rowA == undefined)
        rowA = "9";
      if (rowB == undefined)
        rowB = "9";
      if (rowA.slice(2,3)=="/" || rowB.slice(2,3)=="/") {
        // Case of a date
        rowA = rowA.slice(6,10)+rowA.slice(3,5)+rowA.slice(0,2);
        rowB = rowB.slice(6,10)+rowB.slice(3,5)+rowB.slice(0,2);
      }
      if (typeof column == 'string') {
        var rowA = rowA.toLowerCase();
        var rowB = rowB.toLowerCase();
      }
      if (rowA < rowB)
        return -1 * sortOrder;
      else if (rowA > rowB)
        return 1 * sortOrder;
      else return 0
    });
  }

  onClickMachine(id: number) {
    this.router.navigate(['installation', id]);
  }


}
